import { gql } from '@apollo/client';

export default gql`
  mutation updateMeals(
    $bookingReference: String!
    $outbound: [InputMeal!]
    $inbound: [InputMeal!]
    $applySalesRestrictionOverrides: Boolean = false
  ) {
    updateMeals(
      bookingReference: $bookingReference
      outbound: $outbound
      inbound: $inbound
      applySalesRestrictionOverrides: $applySalesRestrictionOverrides
    ) {
      reference
    }
  }
`;
